export enum EJoinType
{
    /// <summary>
    /// None
    /// </summary>
    N = 1,
    /// <summary>
    /// Joined
    /// </summary>
    J = 2,
    /// <summary>
    /// Fold
    /// </summary>
    F = 3,
    /// <summary>
    /// Rotate
    /// </summary>
    R = 4,
}